import { render, staticRenderFns } from "./obsolete.vue?vue&type=template&id=dc932a90&scoped=true&"
import script from "./obsolete.vue?vue&type=script&lang=js&"
export * from "./obsolete.vue?vue&type=script&lang=js&"
import style0 from "./obsolete.vue?vue&type=style&index=0&id=dc932a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc932a90",
  null
  
)

export default component.exports